// extracted by mini-css-extract-plugin
export default {"navigation":"navigation_navigation__zKrkh","logo":"navigation_logo__eI0er"};